import { createSlice } from '@reduxjs/toolkit'
import { timeutil } from 'sharedresources';
export const loginSlice = createSlice({
  name: 'login',
  initialState: {
    isSignIn: false,
    isLoading: false,
    firebase: null,
    confirmationResult: undefined,
    operationType: undefined,
    channels: {},
    newUsers: [],
    attachmentProgress: undefined,
    allFilesUploaded: false,
    authSuccess: false,
    authEmail: undefined,
    userSheetLoader: false,
    loggedInData: null,
    teacherUpdated: "",
    illumineConnection: null,
    illumineConnectError: null
  },
  reducers: {
    signIn: (state, action) => {
      state.isLoading = true
    },
    initLogin: (state, action) => {
      state.isLoading = true
    },

    logout: (state, action) => {
      state.isLoading = true;
    },

    requestFailed: (state, action) => {
      state.isLoading = false
    },

    loginSuccess: (state, action) => {
      state.firebase = { ...state.firebase, ...action.payload };
      state.loggedInData = { ...state.firebase, ...action.payload };
      state.isLoading = false;
      state.operationType = "SIGN_SUCCESS";
    },
    parentSignSuccess: (state, action) => {
      state.loggedInData = action.payload;
      state.firebase = action.payload;
      state.isLoading = false;
      state.operationType = "PARENT_SIGN_SUCCESS";
    },

    logoutSuccess: (state, action) => {
      state.firebase = undefined;
      state.isLoading = false;
      state.newUsers = [];
      state.operationType = "LOGOUT_SUCCESS";
    },

    validateUserLogin: (state, action) => {
      state.isLoading = true;
    },

    updateChannel: (state, action) => {
      let key = action.payload.key;
      let val = action.payload.val;
      state.channels[key] = val;
    },

    closeChannels: (state, action) => {
      for (const key in state.channels) {
        if (state.channels[key]) {
          state.channels[key].close();
        }
      }
    },

    closeChannelByKey: (state, action) => {
      let key = action.payload;
      if (state?.channels[key]) {
        console.log("state.channels[key]", state.channels[key])
        // state.channels[key].close();
      }
    },

    updateFirebaseObj: (state, action) => {
      let key = action.payload.key;
      let val = action.payload.val;
      state.firebase = { ...state.firebase, [key]: val };
    },
    signUpAccount: (state, action) => {
      state.isLoading = true
    },
    signUpSuccess: (state, action) => {
      state.isLoading = false;
      state.operationType = "SIGN_UP_SUCCESS";
    },
    attachmentUploadProgress: (state, action: any) => {
      state.allFilesUploaded = action.allFilesUploaded,
        state.attachmentProgress = state.attachmentProgress && action.moreThanOne ? state.attachmentProgress + action.attachmentProgress : action.attachmentProgress
    },
    sliceOperation: (state, action) => {
      if (action.payload) {
        Object.assign(state, action.payload);
      }
    },
    setFirebaseObj: (state, action) => {
      if (action.payload) {
        action.payload?.schoolConfig?.timezone && timeutil.setDefaultTimezone(action.payload.schoolConfig.timezone);
        state.firebase = { ...state.firebase, ...action.payload };
        state.loggedInData = { ...state.firebase, ...action.payload };
        state.isLoading = false;
        state.operationType = '';
      }
    },
    setNewUsers: (state, action) => {
      state.newUsers = action.payload.newUsers;
      state.operationType = action.payload.operationType;
      state.userSheetLoader = false
    },
    continueWithNewUser: (state, action) => {
      state.userSheetLoader = true
    },
    resetUploadProgress: (state, action) => {
      state.allFilesUploaded = false,
        state.attachmentProgress = undefined
    },
    fetchNewUsers: (state, action) => {
      state.userSheetLoader = true
    },
    authenticationSucess: (state, action) => {
      state.authSuccess = action.payload.authSuccess;
      state.isLoading = false;
    },
    setLoading: (state, action) => {
      state.isLoading = true;
    },
    sagaFailed: (state, action) => {
      state.isLoading = false
    },
    getSchoolConfig: (state, action) => { },
    resetOperationTypeLogin: (state, action) => {
      state.operationType = undefined
      state.teacherUpdated = undefined
    },
    setTeachersFetched: (state, action) => {
      state.teacherUpdated = "TEACHERS_FETCHED"
    },
    handoffLogin: (state, action) => {
      state.isLoading = true;
      state.operationType = undefined;
    },
    connectIllumineSchool: (state, action) => {
      state.isLoading = true;
      state.operationType = undefined;
      state.illumineConnection = null;
      state.illumineConnectError = null;
    }
  }
})

export const { signIn,
  requestFailed, logout, loginSuccess, logoutSuccess,
  validateUserLogin, getSchoolConfig, setTeachersFetched,
  closeChannelByKey, closeChannels, updateChannel, updateFirebaseObj, signUpAccount, attachmentUploadProgress,
  sliceOperation, continueWithNewUser, resetUploadProgress, fetchNewUsers,
  authenticationSucess, initLogin, setLoading, sagaFailed, resetOperationTypeLogin, setFirebaseObj, handoffLogin,
  connectIllumineSchool } = loginSlice.actions

export default loginSlice.reducer
